<header class="invite-form__header">
  <span>{{ strategy.header | translate }}</span>
</header>

<section class="invite-form__body">
  <p class="invite-form__description">
    {{ strategy.description | translate }}
  </p>

  <form #inviteForm="ngForm" (ngSubmit)="onSubmit()">
    <ocp-email-chips-input
      #chips
      name="emails"
      [ngModel]="emails()"
      required
      (ngModelChange)="emails.set($event)"
      [placeholder]="strategy.emailPlaceholder | translate"
    />

    <div class="invite-form__actions">
      <button
        hlmBtn
        type="submit"
        class="invite-form__submit-button"
        [disabled]="!chips.canSubmit()"
      >
        <ocp-themed-icon
          [name]="chips.canSubmit() ? 'checkmark.svg' : 'checkmark-disabled.svg'"
          mode="swap"
        />
        {{ strategy.inviteButtonLabel | translate }}
      </button>
      <button
        hlmBtn
        type="button"
        variant="secondary"
        class="invite-form__cancel-button"
        (click)="dynamicDialogRef?.close()"
      >
        <ocp-themed-icon name="cross.svg" />
        {{ strategy.cancelButtonLabel | translate }}
      </button>
    </div>
  </form>
</section>
